// extracted by mini-css-extract-plugin
module.exports = {"saveButtonFixed":"SaveButton_saveButtonFixed__2dIIy","buttonsContainer":"SaveButton_buttonsContainer__3Y5Iv","processingSync":"SaveButton_processingSync__WDcxn"};